import { PersonLivingStatus } from '../api/generated/person-controller/person-controller.ts';

export function getLivingStatusName(status: PersonLivingStatus) {
  switch (status) {
    case PersonLivingStatus.ALIVE:
      return 'Lebt';
    case PersonLivingStatus.DECEASED:
      return 'Verstorben';
  }
}
